export const RegisterStepMixin = {
  data() {
    return {
      trackerLoaded: false
    }
  },
  methods: {
    closeRegister() {
      this.$dialog.confirm({
        message: '¿Estás seguro de que quieres cancelar el registro?',
        onConfirm: () => {
          if (this.isApp === false) {
            this.$router.push('/register').catch(error => {
              console.info(error.message)
            })
          } else {
            this.sendEventMobile('register/cancel')
          }
        }
      })
    },
    closeRegisterNoConfirm() {
      if (this.isApp === false) {
        this.$router.push('/register').catch(error => {
          console.info(error.message)
        })
      } else {
        this.sendEventMobile('register/cancel')
      }
    },
    getFieldInfo(fieldName) {
      if (this.getCurrentConfiguration && this.getCurrentConfiguration.campos)
        return this.getCurrentConfiguration.campos[fieldName]
      else return undefined
    },
    sendEventMobile(eventname) {
      window.location.href = `tokmed://${eventname}`
    },
    prevStep() {
      this.$store.commit('register/prevStep')
    }
  },
  computed: {
    isApp() {
      return this.$store.state.isApp
    },
    getRegisterConfiguration() {
      return this.$store.state.register.registerConfiguration
    },
    getCurrentConfiguration() {
      if (this.currentRole === '') return null
      else {
        return this.getRegisterConfiguration.data.filter(
          d => d.rol === this.currentRole
        )[0]
      }
    },
    currentRole: {
      get() {
        return this.$store.state.register.role
      },
      set(value) {
        this.$store.commit('register/setRole', value)
      }
    },
    currentCountry: {
      get() {
        return this.$store.state.register.country
      },
      set(value) {
        this.$store.commit('register/setCountry', value)
      }
    },
    texts: function() {
      return this.$store.state.decoupled.configFile.texts
    },
    config: function() {
      return this.$store.state.decoupled.configFile.config
    }
  }
}
